import React, { useState, useRef, useCallback } from "react";
import { CSSTransition } from "react-transition-group";

import styles from "./BrewInstallInstructions.module.css";

const BrewInstallInstructions: React.FC = () => {
  const [brewInstructionsHovered, setBrewInstructionsHovered] = useState(false);
  const [popoverText, setPopoverText] = useState("Copy code to clipboard");
  const popoverRef = useRef(null);

  const handleCopy = useCallback<React.MouseEventHandler>((event) => {
    event.preventDefault();

    navigator.clipboard.writeText("brew install --cask raycast");
    setPopoverText("Copied!");

    setTimeout(() => setPopoverText("Copy code to clipboard"), 2000);
  }, []);

  return (
    <a
      className={styles.brewInfo}
      onMouseEnter={() => setBrewInstructionsHovered(true)}
      onMouseLeave={() => setBrewInstructionsHovered(false)}
      onClick={handleCopy}
    >
      <CSSTransition nodeRef={popoverRef} in={brewInstructionsHovered} timeout={300} unmountOnExit classNames={styles}>
        <span ref={popoverRef} className={styles.brewPopover}>
          {popoverText}
        </span>
      </CSSTransition>
      <span className={styles.noSelect}>$</span> brew install --cask raycast
    </a>
  );
};

export default BrewInstallInstructions;
